import React from 'react';

const HeroVideo = () => {
  return (
    <div className="w-full h-screen bg-black overflow-hidden">
      <video
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        className="w-full h-full object-cover"
      >
        <source src="/videos/video5.mp4" type="video/mp4"/>
        Twoja przeglądarka nie obsługuje elementu video lub plik nie został znaleziony.
      </video>
    </div>
  );
};

export default HeroVideo;
